import { render } from "./SuppliersPage.vue?vue&type=template&id=b0ce2a94"
import script from "./SuppliersPage.vue?vue&type=script&lang=js"
export * from "./SuppliersPage.vue?vue&type=script&lang=js"

import exportComponent from "/srv/www/nahodka.xpage.dev/htdocs/public/local/client-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__